import { IS_PRODUCTION } from '@/common/constants';

export const SIGN_IN_LINK_TTL_SECONDS = 15 * 60;

/** No guest session outlives this: Mastra caps one at just under a week. */
export const MAX_SESSION_MS = 7 * 24 * 60 * 60_000;

/** The shortest government ID the gateway accepts. */
export const MIN_GOVERNMENT_ID_LENGTH = 5;

export const OTP_LENGTH = 6;

/** A sign-in route the browser calls. The server takes the tenant from the host, so the path
 *  never names it. */
export function browserAuthPath(
  action: 'signin' | 'cookie-check' | 'complete' | 'token' | 'signout' | 'oauth/callback',
): string {
  return `/api/auth/${action}`;
}

/** The one-time-code endpoint keeps the tenant in its path: the hosted verification page that
 *  calls it is linked from MCP connectors, whose URLs must not change. */
export function verificationPath(tenant: string): string {
  return `/api/auth/${encodeURIComponent(tenant)}/verify`;
}

/** Set on a guest chat answer when the browser's session is gone, so the chat shows the guest
 *  signed out at once instead of at the next session check. */
export const GUEST_SESSION_ENDED = { header: 'x-bazak-guest-session', value: 'ended' } as const;

// `__Host-` pins a cookie to this exact host over HTTPS, so no subdomain can plant or overwrite
// it; plain-HTTP local runs can't use the prefix.
function hostCookieName(name: string): string {
  return `${IS_PRODUCTION ? '__Host-' : ''}${name}`;
}

export function bindingCookieName(tenant: string): string {
  return hostCookieName(`bazak_guest_${tenant}`);
}

/** The script-readable companion of the binding cookie, holding its session's handle. */
export function sessionCookieName(tenant: string): string {
  return hostCookieName(`bazak_guest_session_${tenant}`);
}
